var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Programación de vacaciones\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("strong", [_vm._v("NOMBRE: ")]),
              _vm._v(
                _vm._s(this.$storage.get("user").nombres) +
                  "\n      " +
                  _vm._s(this.$storage.get("user").ap_paterno) +
                  "\n      " +
                  _vm._s(this.$storage.get("user").ap_materno) +
                  "\n      "
              ),
              _c("br"),
              _vm._v(" "),
              _c("strong", [_vm._v("UNIDAD: ")]),
              _vm._v(
                _vm._s(this.$storage.get("user").unidad[0].nombre_unidad) +
                  "\n\n      "
              ),
              _c("crud-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  url: _vm.url,
                  filters: _vm.filters,
                  "data-graphql": _vm.dataGraphql,
                  graphql: _vm.graphql,
                  initData: _vm.initData
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.gestion))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_inicio)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_fin)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_corte)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.porcentaje) + "%")
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _vm.gestion_actual != items.item.gestion
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "info",
                                      to:
                                        "vacaciones-aprobar-jefe-superior/" +
                                        items.item.gestion,
                                      icon: "",
                                      title: "Ver programaciones de vacación"
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("remove_red_eye")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.gestion_actual == items.item.gestion
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "info",
                                      to:
                                        "vacaciones-aprobar-jefe-superior/" +
                                        items.item.gestion,
                                      icon: "",
                                      title: "Ver programaciones de vacación"
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("list ")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80954184", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80954184","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/ListadoGestionesPorUnidad.vue
// module id = null
// module chunks = 